import { ICup, ILeagueContestants, IMatch, ILeague, IContestant, IUser } from "../../typings/typings";
import { League } from "./League";
import { sortBy, find } from "lodash";
import { LeagueMatchResource } from "../../services/api/eslapi/LeagueMatchResource";
import { Match } from "./Match";
import { IApiFFAMatchResult } from "ng-league";

export class FFA extends League implements ICup {
    public state: string;
    public prizePool;
    public contestants: ILeagueContestants;

    constructor(jsonData) {
        super(jsonData);
        this.state = jsonData.state;
        this.prizePool = jsonData.prizePool;
        this.contestants = jsonData.contestants;
        this.upcomingMatchesStates = { open: 100, challenge: 0, protest: 0 };
        this.recentResultsCount = { closed: 6, protest: 0 };
    }

    public isFull() {
        if (
            typeof this.contestants !== "object" ||
            isNaN(this.contestants.max) ||
            this.contestants.max === null ||
            this.contestants.max === 0
        ) {
            return false;
        }

        return this.contestants.checkedIn >= this.contestants.max;
    }

    public isCheckInAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("checkIn");
    }

    public isSignUpAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("signUp") && this.timeline.signUp.begin;
    }

    public isPostSignUpAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("postSignUp");
    }

    public hasLateSignUp() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("lateSignUp");
    }

    public getStartDate(): Date {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("inProgress")
            ? new Date(this.timeline.inProgress.begin)
            : new Date(0);
    }

    public getNextDate(): Date {
        if (
            this.state !== "finished" &&
            typeof this.timeline === "object" &&
            this.timeline.hasOwnProperty(this.state) &&
            this.timeline[this.state].hasOwnProperty("end")
        ) {
            return new Date(this.timeline[this.state].end);
        }

        return new Date(0);
    }

    /**
     * Override templates
     * @param template
     * @param $filter
     * @param $scope
     * @returns {string}
     */
    public getUrlByTemplate(template: string, $filter, $scope) {
        switch (template) {
            case "Match":
                return $filter("sprintf")($scope.templateUrls.templateMatchUrl, "ffa");
            case "Result":
                return $filter("sprintf")($scope.templateUrls.templateResultUrl, "ffa");
            default:
                return super.getUrlByTemplate(template, $filter, $scope);
        }
    }

    public getState(): string {
        return this.state;
    }

    public getCurrentMatch(matches): IMatch {
        if (matches.open.length > 0) {
            return sortBy(matches.open, (match: any) => match.position)[0];
        }

        if (matches.challenge.length > 0) {
            return matches.challenge[0];
        }

        return null;
    }

    public refreshMatchData(
        league: ILeague,
        user: IUser,
        contestant: IContestant,
        LeagueMatchResource: LeagueMatchResource,
        $q: ng.IQService
    ): angular.IPromise<IMatch[]> {
        return super.refreshMatchData(league, user, contestant, LeagueMatchResource, $q).then(matches => {
            return LeagueMatchResource.getMatchResults(+league.id).then((results: IApiFFAMatchResult[]) => {
                return matches.map((match: Match) => {
                    const result = find(results, r => r.id === +match.id);

                    match.position = result ? result.position : null;
                    match.round = result ? result.round : null;
                    match.group = result ? result.group : null;

                    return match;
                });
            }) as any;
        });
    }

    public refreshResultData(
        league: ILeague,
        user: IUser,
        contestant: IContestant,
        LeagueMatchResource: LeagueMatchResource,
        $q: angular.IQService
    ): angular.IPromise<IMatch[]> {
        return super.refreshResultData(league, user, contestant, LeagueMatchResource, $q).then(matches => {
            return LeagueMatchResource.getMatchResults(+league.id).then((results: IApiFFAMatchResult[]) => {
                return matches.map((match: Match) => {
                    const result = find(results, r => r.id === +match.id);

                    match.position = result ? result.position : null;
                    match.round = result ? result.round : null;
                    match.group = result ? result.group : null;

                    return match;
                });
            }) as any;
        });
    }
}
